import PeopleIcon from "../../icons/people";
import Popup from "../popup";
import styles from "./index.module.scss";

const JoinCommunity = () => {
  return (
    <Popup
      content={
        <div className={styles.content}>
          <img
            src="https://python2fun.oss-cn-beijing.aliyuncs.com/pythontip-portal/images/wechat-group.png"
            alt=""
          />
          <div className={styles.tips}>微信扫一扫加入 PythonTip 社区</div>
        </div>
      }
    >
      <div className={styles.button}>
        <PeopleIcon />
        加入社区
      </div>
    </Popup>
  );
};

export default JoinCommunity;
